<template>
    <span>{{ Math.floor(stars / 1000) || 20 }}</span>
</template>


<script setup>
const stars = useState("gh-stars")
</script>
